import { defaultFont } from "assets/jss/material-dashboard-react.js";

const footerStyle = {
  block: {},
  left: {
    float: "left !important",
    display: "block",
  },
  right: {
    padding: "12px 0",
    margin: "0",
    fontSize: "13px",
    float: "right !important",
  },
  footer: {
    bottom: "0",
    borderTop: "1px solid #f0f4f8",
    padding: "12px 24px",
    ...defaultFont,
  },
  container: {
    paddingRight: "15px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto",
  },
  a: {
    color: "#1a73e8",
    textDecoration: "none",
    backgroundColor: "transparent",
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
};

export default footerStyle;
